import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';
export class FeedBack {
    replayQueue = {}
    plugins: { pluginName: string; range: (config: AxiosRequestConfig) => boolean; check: (response: AxiosResponse) => boolean; fix: (response: AxiosResponse) => Promise<void>; spiderGroupId: number; holdingPromise?: Promise<void> }[] = []
    _seed = 9999
    interceptor: { hold: (config: AxiosRequestConfig) => Promise<AxiosRequestConfig>; replay: (instance: any) => (response: AxiosResponse) => Promise<AxiosResponse> } = {} as any
    constructor(plugins) {
        if (typeof window === 'undefined') return
        plugins.forEach(({ name: pluginName, active, range, check, fix }) => {
            if (typeof pluginName !== 'string' || typeof active !== 'function' || typeof range !== 'function' || typeof check !== 'function' || typeof fix !== 'function') return
            if (!active()) return
            this.plugins.push({ pluginName, range, check, fix, spiderGroupId: 0 })
        })
        this.interceptor = {
            hold: this._hold.bind(this),
            replay: instance => response => this._replay(response, instance),
        }
    }

    async _hold(config) {
        if (!config.customdata) config.customdata = {}
        config.customdata.spiderGroupId = {}
        await Promise.all(this.plugins.map(async plugin => {
            if (plugin.range(config)) await plugin.holdingPromise
            config.customdata.spiderGroupId[plugin.pluginName] = plugin.spiderGroupId
        }))
        return config
    }

    async _replay(response, schttp: AxiosInstance) {
        const responseGroupId = response.config?.customdata?.spiderGroupId
        if (!responseGroupId) return response
        // 来自重放流量
        const sourceReplayId = response.config.headers['x-gw-replay']
        if (sourceReplayId) {
            // 原流量接管
            this.replayQueue[sourceReplayId](response)
            delete this.replayQueue[sourceReplayId]
            // 终止重放请求
            throw new Error('abandon from replay')
        }

        let isOk = true
        let fixFaild = false
        await Promise.all(this.plugins.map(async plugin => {
            if (plugin.check(response)) {
                isOk = false
                const fixSuccess = await this._doFix(response, responseGroupId, plugin)
                if (!fixSuccess) fixFaild = true
            }
        }))
        // 来自正常流量或者修复失败
        if (isOk || fixFaild) return response

        // 无感重放
        const uniqueId = this._createUniqueId()
        const promise = this._saveQueue(uniqueId)
        try {
            // 特殊处理json
            response.config.data = JSON.parse(response.config.data)
            // eslint-disable-next-line no-unused-vars
        } catch (error) {
            // console.log('schttp parse')
        }
        const config = this._resetConfig(uniqueId, response.config)
        schttp(config).catch(e => console.log('replay success: ', e.message === 'abandon from replay'))

        return promise
    }

    async _doFix(response, responseGroupId, plugin) {
        /**
         * 同组且没更新过才会发起
         * 否则返回当前的 promise (若有, 来自本次或后续批次)
         * 没有则返回 null 直接重发
         */
        if (responseGroupId[plugin.pluginName] !== plugin.spiderGroupId || plugin.holdingPromise) return plugin.holdingPromise

        return plugin.holdingPromise = (async () => {
            let fixSuccess = true
            try {
                await plugin.fix(response)
            } catch (error) {
                console.error(error)
                fixSuccess = false
            }
            // 更新完签名, 后续请求分到下一批次
            plugin.spiderGroupId++
            delete plugin.holdingPromise
            return fixSuccess
        })()
    }

    _createUniqueId() {
        if (this._seed < 1000) this._seed = 9999
        return this._seed--
    }

    _saveQueue(key) {
        let resolve: any = null
        const promise = new Promise(res => resolve = res)
        this.replayQueue[key] = resolve
        return promise
    }

    _resetConfig(key, config) {
        config.headers['x-gw-replay'] = key
        // 从根级去除, 以免新的 common 混不进来
        delete config.headers['x-gw-auth']
        delete config.headers['x-csrf-token']
        return config
    }
}



